<template>
  <NuxtLayout class="tw-font-sans">
    <NuxtPage />
    <TheToast />
    <TheModal />
    <VueQueryDevtools :initial-is-open="false" />
  </NuxtLayout>
</template>

<script setup lang="ts">
import { VueQueryDevtools } from '@tanstack/vue-query-devtools'
</script>
